export default __webpack_public_path__ + "static/discover-the-aurora-borealis-on-your-next-holiday-greenland-19c418d5d5e0878ac9646cefc84d990e.jpg";